import { render } from "./Terms.vue?vue&type=template&id=5e56f060"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__